import React from "react";
import { Alert, Button } from 'react-bootstrap';
import Aux from '../../../hoc/Aux';

const successResult = (props) => {

  return (
    <Aux>
        <Alert variant="success">
        <Alert.Heading>Broneerimine õnnestus!</Alert.Heading>
        <p>
          Teie broneering on edastatud teenindusele ning broneeringu kinnitus saadetud ka Teie e-maili aadressile.
        </p>
      </Alert>
      <Button className="mt-2" variant="primary" onClick={props.newBtnClicked}>Broneeri veel</Button>
    </Aux>
  );

}

export default successResult;